<template>
  <div class="container">
    <section class="intro-single">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-8">
            <div class="title-single-box"><h1 class="title-single">Current
              Studies</h1><span
              class="color-text-a">LASR Lab - Vanderbilt University Medical Center</span></div>
          </div>
          <div class="col-md-12 col-lg-4">
            <nav aria-label="breadcrumb" class="breadcrumb-box d-flex justify-content-lg-end">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/"
                                               class="router-link-active">Home</a></li>
                <li aria-current="page" class="breadcrumb-item active">
                  Current Studies
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <section class="section-studies">
      <div class="container">
        <div class="row">
          <div class="col-md-12 section-t1">
            <div class="row">
              <div class="col-md-12"><h4>We are currently seeking new participants
                for {{studies.length}} studies</h4>
                <div class="button-container"><h5>Are you interested in studies
                  for children or adults?</h5>
                  <button class="btn btn-lg " @click="children = !children"
                          :class="!children ? 'btn-info' : 'btn-primary'">Children
                  </button>
                  <button class="btn btn-lg btn-primary" @click="adults = !adults" :class="!adults ? 'btn-info' :
                  'btn-primary'">Adults
                  </button>
                </div>
                <div class="card" v-for="s in studies" v-if="(s.type === 'adult' && adults) || (s.type === 'children' &&
                children) || (s.type === 'both' && (adults || children))">
                  <div class="card-body"><h5 class="card-title">{{s.name}}</h5>
                    <div class="card-text"><h6>Goal of Study</h6>
                      <div>{{s.goal}}
                      </div>
                      <h6>Time Commitment</h6>
                      <div>{{s.time}}
                      </div>
                      <h6>What's Involved?</h6>
                      <div>{{s.involved}}
                      </div>
                      <h6>Eligibility</h6>
                      <div>{{s.eligibility}}
                      </div>
                      <h6>Compensation</h6>
                      <div>{{s.compensation}}</div>
                      <p>To volunteer for this study please contact:</p>
                      <div>{{s.contact}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: "Studies",
    data: function () {
      return {
        adults: false,
        children: false,
        studies: [{
          name: "Brain Imagining of Visual Processing in Autism",
          goal: "To investigate how the brain processes vision and how these processes may be different in individuals with autism spectrum disorder.",
          time: "You may qualify to participate in up to two 1.5 to 3 hour sessions.",
          involved: "Session 1: You will answer questions from the psychologist and fill out some questionnaires. Session 2: You will be scanned in an MRI scanner.",
          eligibility: "We are looking for participants who:\n- are 18-50 years of age.\n- have autism spectrum disorder OR are typically developing.",
          compensation: "The study pays $20 per hour. You will also get a picture of your brain!",
          contact: "Email: autismlasr@vumc.org\nPhone: (615) 936-7220 / (615) 936-0151",
          type: "adult"
        }, {
          name: "Bridging the Internal and External Worlds in Autism",
          goal: "To understand how the brain and body respond to sensory information, how these responses may be different in individuals with autism, and what effects that has on emotions, specifically anxiety.",
          time: "You may qualify to participate in up to five 2 to 4 hour sessions.",
          involved: "Session 1: You (or your child) will answer questions from the psychologist and fill out some forms about your feelings, behavior, and health. Session 2 and 3: You (or your child) will do some games on the computer while a sensor measures your heartbeats, breathing, and sweat while having an EEG – you (or your child) will wear a stretchy cap that records signals from your brain. Some games will be looking at pictures or videos and answering questions, some will be matching pictures to the feeling of your heartbeat. Session 4: You (or your child) will be scanned in an MRI scanner. If you are taking a certain kind of medication, we may ask you to skip a dose on the day of the MRI scan. You may come to the lab a fifth time if there is something you didn’t finish in the other visits.",
          eligibility: "We are looking for participants who:\n-have autism spectrum disorder OR are typically developing \n- are between the ages of 8 and 17 OR between the ages of 18-50\n-can consistently follow verbal instructions\n-speak English fluently OR are primarily Spanish speaking\n-do AND do not have an autism spectrum disorder",
          compensation: "The study pays $15/hour and you receive a $25 bonus if you complete all of the questionnaires. Your parking at Vanderbilt will be paid for. If you participates in the MRI portion of the study, you will also get a picture of your brain!",
          contact: "Email: autismlasr@vumc.org\nPhone: (615) 936-7220 / (615) 936-0151",
          type: "both"
        }]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Studies.vue